import React from 'react';

import { DateService, useEventState } from '@atlas/core';

const EventStartTime = () => {
  const event = useEventState();
  const { startTime } = event;
  if (!startTime) return null;

  const formattedDate = DateService.getFormattedDateWithTime(startTime);

  return <div className="date-time sub-title-xsmall-500-text">{formattedDate}</div>;
};

export default EventStartTime;
